import React, { useEffect } from "react";
import CPlaceMark from "../CPlaceMark";
import img from '../../../../../assets/images/busCircle.svg';
import imgBusLowFloor from '../../../../../assets/images/busWithlowFloor.svg';
import imgTram from '../../../../../assets/images/Tram_Icon_Transparent.svg';
import imgTramWithFloor from '../../../../../assets/images/tramwithfloor.svg';
import styled from "styled-components";
import DirectionArrow from "./DirectionArrow";
import imgArrow from "../../../../../assets/images/arrow-up-svgrepo-com.svg";
import imgTransparent from "../../../../../assets/images/transparent.svg";

const TransportOnMap = ({
    ymapsApi,
    longitude,
    latitude,
    id,
    hintContent,
    size,
    handlePlacemarkClick,
    isLowFloor,
    type = 'АВТОБУС',
    degree,
}
    : {
        ymapsApi: any,
        id: number,
        longitude: number,
        latitude: number,
        hintContent?: string,
        size: [number, number],
        handlePlacemarkClick: () => void,
        isLowFloor?: boolean,
        type?: 'АВТОБУС' | 'ТРАМВАЙ',
        degree?: number;
    }) => {

    const images = {
        'АВТОБУС': isLowFloor ? imgBusLowFloor : img,
        'ТРАМВАЙ': isLowFloor ? imgTramWithFloor : imgTram
    }

    const angle = degree ?? 0; // градусы
    const radius = size[0] * 0.7; // 40% от ширины // px от центра

    const angleRad = (angle - 90) * (Math.PI / 180); // смещение от вертикали вверх
    const centerX = size[0]/2;
    const centerY = size[1]/2; // центр иконки транспорта 

    const arrowLeft = centerX + radius * Math.cos(angleRad) - 9.5; // 9.5 — половина ширины стрелки (19px)
    const arrowTop = centerY + radius * Math.sin(angleRad) - 9.5;

    const contentLayout = ymapsApi?.templateLayoutFactory.createClass(
        `
        <div style="position: relative; width: ${size[0]}px; height: ${size[1]}px;>
            <img src="${img}" style="position: absolute; width: ${size[0]}px; height: ${size[1]}px; left: 0; top: 0;" />
            <img 
                src="${imgArrow}" 
                style="
                    position: absolute;
                    width: 19px;
                    height: 19px;
                    left: ${arrowLeft}px;
                    top: ${arrowTop}px;
                    transform: rotate(${angle}deg);
                    z-index:99999;
                "
            />
        </div>
        `,
        {
            build: function () {
                // @ts-ignore
                this.constructor.superclass.build.call(this);
            },
            clear: function () {
                // @ts-ignore
                this.constructor.superclass.clear.call(this);
            },
        }
    );

    useEffect(()=>{
        //{console.log('size', size)}
    },[size])

    //if (!degree) return null;

    return (
        <Container style={{ width: size[0], height: size[1] }}>
            <CPlaceMark
                ymapsApi={ymapsApi}
                handlePlacemarkClick={handlePlacemarkClick}
                iconImageHref={images[type.toUpperCase()]}
                // iconImageHref={degree ? imgTransparent : images[type.toUpperCase()]}
                hintContent={hintContent}
                geometry={[latitude, longitude]}
                iconImageSize={size}
                customComponent={degree ? contentLayout : undefined}
                zIndex={999}
            /> 
        </Container>
    )
}

export default React.memo(TransportOnMap);

const Container = styled.div`
    position: relative;
`;

// const customPlacemark = () => {
//     return (
//         <PlaceMark>
//             <p>111</p>
//         </PlaceMark>
//     )
// }

// const PlaceMark = styled.div`

// `